import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getContributionsByAgeChartKey = 'getContributionsByAgeChart';
export interface ContributionsByAgeChartState {
  loadContributionsByAgeChartResponse: IDistributionChart[];
  loadContributionsByAgeChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: ContributionsByAgeChartState = {
  loadContributionsByAgeChartResponse: undefined,
  loadContributionsByAgeChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadContributionsByAgeChart, (state, action) => ({
    ...state
  })),
  on(actions.loadContributionsByAgeChartSuccess, (state, action) => ({
    ...state,
    loadContributionsByAgeChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadContributionsByAgeChartFailure, (state, action) => ({
    ...state,
    loadContributionsByAgeChartResponseFailure: action.error
  }))
);

export const getContributionsByAgeChart = (state: ContributionsByAgeChartState) => {
  if (state && state.loadContributionsByAgeChartResponse) return JSON.parse(JSON.stringify(state.loadContributionsByAgeChartResponse));
  else return null;
};

export const getContributionsByAgeChartIsLoaded = (state: ContributionsByAgeChartState) => {
  state.loaded;
};
